import Mosaic from 'mosaic-framework';

export default new Mosaic({
    name: 'code-segment',
    data: {
        type: 'HTML'
    },
    created() {
        this.tabIndex = 0;
    },
    view() {
        return html`
            <span class='code-seg-type'>${this.data.type}</span>
            ${this.descendants}
        `
    }
})